const siteTitle = "Randy Gulak | Portfolio";

export { siteTitle };
